import { array, string } from 'fp-ts';

interface ObservePerformanceOptions {
    context: typeof window;
    entryTypes: string[];
    callback: PerformanceObserverCallback;
}

const observePerformance = ({ context, callback, entryTypes: requestedEntryTypes }: ObservePerformanceOptions) => {
    if (context.PerformanceObserver?.supportedEntryTypes) {
        const entryTypes = array.intersection(string.Eq)(requestedEntryTypes, [
            ...context.PerformanceObserver.supportedEntryTypes,
        ]);

        if (array.isNonEmpty(entryTypes)) {
            const performanceObserver = new context.PerformanceObserver(callback);
            performanceObserver.observe({ entryTypes });
            return performanceObserver;
        }
    }
};

export default observePerformance;
